// redux
/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
   sequencerInstrumentControlTypes,
   sequencerViewTypes,
} from '../constants';
import { MiniPianoRollDisplay } from './MiniPianoRollDisplay';
import { togglePart, setView } from '../actions';
import { StepSequencerRow } from './StepSequencerRow';
import { StepSequencerCursor } from './StepSequencerCursor';
import { SequencerProgress } from '../SequencerProgress';

const InstrumentName = styled.span`
   display: block;
   line-height: 45px;
   padding: 5px 5px 5px 0;
   font-family: var(--content-font);
   font-weight: bold;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
`;

const mapStateToProps = ({
   activeInterface: {
      instrumentRack,
      partsPerBeat,
      compareAnswer,
      highlightedControls,
      beatCount,
      noteRange,
   },
}) => ({
   instrumentRack,
   partsPerBeat,
   compareAnswer,
   highlightedControls,
   beatCount,
   noteRange,
});

const mapDispatchToProps = {
   togglePart,
   setView,
};

const StepSequencer = connect(
   mapStateToProps,
   mapDispatchToProps
)(
   ({
      instrumentRack,
      partsPerBeat,
      compareAnswer,
      highlightedControls,
      togglePart,
      setView,
      beatCount,
      noteRange,
   }) => (
      <div className="step-sequencer">
         <SequencerProgress />
         <div className="step-sequencer-rows">
            <div>
               {instrumentRack.map(({ source, name, id }) => (
                  <InstrumentName key={id}>{name || source}</InstrumentName>
               ))}
            </div>
            <div className="step-sequencer-row-outer-wrapper">
               <div
                  className="step-sequencer-row-inner-wrapper"
                  style={{ '--step-count': beatCount * 4 }}
               >
                  {instrumentRack.map(
                     (
                        { pattern, referencePattern, id, controlType },
                        instrumentIndex
                     ) => (
                        <div key={id} className="step-sequencer-row">
                           {controlType ===
                           sequencerInstrumentControlTypes.stepSequencer ? (
                              <StepSequencerRow
                                 highlightedControls={highlightedControls}
                                 pattern={pattern}
                                 referencePattern={referencePattern}
                                 partsPerBeat={partsPerBeat}
                                 instrumentIndex={instrumentIndex}
                                 onToggle={(e) =>
                                    togglePart(
                                       instrumentIndex,
                                       e.currentTarget.dataset.partIndex
                                    )
                                 }
                              />
                           ) : (
                              <MiniPianoRollDisplay
                                 pattern={pattern}
                                 referencePattern={referencePattern}
                                 compareAnswer={compareAnswer}
                                 onClick={() =>
                                    setView({
                                       viewType: sequencerViewTypes.pianoRoll,
                                       instrumentIndex,
                                       noteRange:
                                          instrumentRack[instrumentIndex]
                                             .noteRange || noteRange,
                                    })
                                 }
                              />
                           )}
                        </div>
                     )
                  )}
                  <StepSequencerCursor rows={instrumentRack.length} />
               </div>
            </div>
         </div>
      </div>
   )
);

export { StepSequencer };
